<template lang="pug">
v-container#package-tables(fluid, tag="div")
  h3 Services Avaiable
  v-item-group(active-class="primary")
    v-container
      v-row(v-if="service_list.length")
        v-list(three-line)
          v-list-item-group
            template(v-for="(item, index) in service_list")
              v-list-item(:key="`service ${item.service_id}`" @click="goto(item)")
                v-list-item-icon
                  v-icon(v-text="item.icon")
                v-list-item-content
                  v-list-item-title.text-info {{ item.name }}
                  v-list-item-subtitle 
                    strong {{ item.description }}
                  v-list-item-subtitle RM {{ item.pricing }} /use
                    small.text-danger.ml-4 &nbsp;Charging package: {{ item.package_id }}
                v-list-item-action.m-auto
                  v-icon(color="#2CC54E") mdi-arrow-right
              v-divider(v-if="index < service_list.length - 1", :key="index")
        //- v-col(
        //-   v-for="item in service_list",
        //-   :key="item.service_id",
        //-   cols="12",
        //-   md="4"
        //- )
        //-   v-item(v-slot="{ active, toggle }")
        //-     v-card.d-flex.align-center(
        //-       light,
        //-       height="400",
        //-       @click="goto(item)"
        //-     )
        //-       v-scroll-y-transition
        //-         .display-3.flex-grow-1.text-center.p-4
        //-           h3.text-info.mb-4 {{ item.name }}
        //-           h4.text-success - Price -
        //-           h5 RM {{ item.pricing }}
        //-           h6.form-control.mt-4 {{ item.description }}
      v-row(v-else)
        h3.text-info No service avaiable.
</template>

<script>
export default {
  name: "Package",
  data() {
    return {
      expanded: [],
      search: "",
      editedIndex: -1,
      dialog: false,
      editedItem: {},
      service_list: [],
      service_id: {
        1: "ocr",
        2: "fr",
        3: "landmark",
        4: "liveness",
        5: "upload",
      },
      valid: true,
      loading: false,
    };
  },
  mounted() {
    this.getServiceList();
  },
  methods: {
    goto(item) {
      this.$router.push(
        "/portal/user/" + this.service_id[item.service_id]
      );
    },
    getServiceList() {
      const url = "https://saas-api.xendity.com/v1/user/available-service";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then((response) => {
          // Success
          try {
            if (response) {
              if (response.body.success == false)
                this.$swal(
                  "Get available service list failed",
                  response.body.data.message,
                  "error"
                );
              else this.service_list = response.body.data.service_list;
            }
          } catch (error) {
            this.$swal(
              "Get available service list failed",
              response.body.data.message,
              "error"
            );
          }
        })
        .catch((response) => {
          this.$swal(
            "Get available service list failed",
            response.body.data.message,
            "error"
          );
        });
    },
  },
};
</script>